import { WidgetProps } from '../../../../types/WidgetProps';
import { getShippingOptionLabel } from './getShippingOptionLabel';

interface GetShippingPaymentRequestDataReturn {
  shippingAddressRequired: google.payments.api.PaymentDataRequest['shippingAddressRequired'];
  shippingAddressParameters?: google.payments.api.PaymentDataRequest['shippingAddressParameters'];
  shippingOptionRequired: google.payments.api.PaymentDataRequest['shippingOptionRequired'];
  shippingOptionParameters?: google.payments.api.PaymentDataRequest['shippingOptionParameters'];
}

export const getShippingPaymentRequestData = (topProps: WidgetProps): GetShippingPaymentRequestDataReturn => {
  const options: GetShippingPaymentRequestDataReturn = {
    shippingOptionRequired: topProps.requestShipping,
    shippingAddressRequired: topProps.requestShipping,
  };

  if (options.shippingOptionRequired) {
    options.shippingOptionParameters = {
      shippingOptions: topProps?.shippingMethods?.map((option) => {
        const label = getShippingOptionLabel({
          label: option.label,
          amount: option.amount,
          currencyCode: topProps.currency,
          locale: topProps.locale,
        });
        return {
          id: option.identifier,
          label,
          description: option.detail,
        };
      }),
    };
  }

  if (options.shippingAddressRequired) {
    options.shippingAddressParameters = {
      allowedCountryCodes: undefined,
      phoneNumberRequired: true,
    };
  }

  return options;
};
